import { getEventAestheticOrNone } from './registry';

// Small rounded chip showing an aesthetic's two-colour swatch as a diagonal
// gradient. Used on the "Event Aesthetic" button and in the picker rows.
export default function AestheticSwatch({ id, size = 26, radius = 7 }) {
  const a = getEventAestheticOrNone(id);
  const [from, to] = a.swatch || ['#3a3a3c', '#1c1c1e'];
  const gid = `sw_${a.id}`;
  return (
    <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', flexShrink: 0 }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={from} stopOpacity={1} />
          <stop offset="1" stopColor={to} stopOpacity={1} />
        </linearGradient>
      </defs>
      <rect x={0.5} y={0.5} width={size - 1} height={size - 1} rx={radius} ry={radius} fill={`url(#${gid})`} stroke="rgba(255,255,255,0.22)" strokeWidth={1} />
    </svg>
  );
}
